// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OVJddNTuo5OnT4H9T4Ic {
	padding: 16px;
	border-radius: 12px;
	background-color: var(--white);
}
`, "",{"version":3,"sources":["webpack://./src/components/StakedInfo/StakedInfo.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B","sourcesContent":[".stakedInfo {\n\tpadding: 16px;\n\tborder-radius: 12px;\n\tbackground-color: var(--white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stakedInfo": `OVJddNTuo5OnT4H9T4Ic`
};
export default ___CSS_LOADER_EXPORT___;
